import React from "react";
import { IoIosArrowDown } from "react-icons/io";
import { BsGlobe } from "react-icons/bs";
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";
import LanguageDropdown from "../../../components/languageDropdown/LanguageDropdown";
import MenuHelper from "../../../helpers/MenuHelper";
import { NavLink } from "react-router-dom";

const SideBarMenuList = (props) => {

  return (
    <React.Fragment key={props?.i}>
      {(() => {
        const hasSubmenus = Object.values(props?.menuList).some(submenu => submenu.parent_menu_code === props?.v.code);
        if (!hasSubmenus && props?.v.status && (props?.v.location === 'menu' || props?.v.location == 'sub_menu')
          && (props?.v.code != 'language' && props?.v.code != 'deposit' && props?.v.code != 'withdraw' && props?.v.code != 'live-chat' && (props.desktop ? !props.v.footer_menu : props.v.code != 'home'))) {
          return (
            <NavLink to={props?.customLink} onClick={() => props.handleClose()}>
              <MenuHelper t={props.t} ftpPath={props?.playerMenu?.ftp_path} data={props?.v} className={"sidebar-img"} />
            </NavLink>
          );
        } else {
          return (
            <>
              {props?.v?.code == 'language' &&
                <a
                  className={`dropdown-item fade-in ${props.openMenu.includes(props?.v.code) ? "active" : ""
                    }`}
                  onClick={() => {
                    props?.pushMenu(props?.v.code);
                  }}
                >
                  <BsGlobe />
                  {props.t(`${props?.v?.name.toLowerCase().replace(/ /g, '_')}`)}
                  <IoIosArrowDown className="down-arrow" />
                  {props?.openMenu.includes(props?.v.code) && (
                    <div className="sub-menu">
                      {props?.v.code == 'language' && (
                        <LanguageDropdown view="mobile" />
                      )}
                    </div>
                  )}

                </a >
              }
            </>
          );
        }
      })()}
    </React.Fragment>
  );
};

SideBarMenuList.propTypes = {
  preGlobalFilteredRows: PropTypes.any,
};

export default withTranslation()(SideBarMenuList);
